import gql from "graphql-tag";

export const customerApplicationsQuery = gql`
  query customerApplications(
    $orderBy: OrderBy
    $filters: CustomerApplicationsFilters
    $page: Int
    $perPage: Int
  ) {
    customerApplications(orderBy: $orderBy, filters: $filters, page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        companyName
        companyCode
        companyType
        taxNumber
        comment
        status
        createdAt
        region {
          id
          name
        }
        manager {
          id
          name
        }
        user {
          id
          firstName
          lastName
          phone
          email
          roles {
            name
          }
        }
        utmSource
        utmCampaign
        utmMedium
        managerDeadline {
          deadlineAt
          remainingSeconds
          remaining
          isOverdue
          isRunning
        }
      }
    }
  }
`;

export const customerApplicationLogsQuery = gql`
  query customerApplicationLogs($customerApplicationId: ID!, $page: Int, $perPage: Int) {
    customerApplicationLogs(
      customerApplicationId: $customerApplicationId
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        eventTypeLabel
        comment
        statusAtEvent
        userFullName
        userEmail
        createdAt
      }
    }
  }
`;

export const customerApplicationCommentsQuery = gql`
  query customerApplicationComments($customerApplicationId: ID!, $page: Int, $perPage: Int) {
    customerApplicationComments(
      customerApplicationId: $customerApplicationId
      page: $page
      first: $perPage
    ) {
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
      data {
        id
        body
        statusAtEvent
        userFullName
        userEmail
        createdAt
      }
    }
  }
`;

export const dealershipApplicationsAnalyticsQuery = gql`
  query dealershipApplicationsAnalytics(
    $filters: DealershipAnalyticsFilters
    $orderBy: DealershipAnalyticsOrderBy
  ) {
    dealershipApplicationsAnalytics(filters: $filters, orderBy: $orderBy) {
      summary {
        received
        rejected
        rejectedPercent
        inProgress
        inProgressPercent
        dealerCreated {
          total
          newDealer
          addedToExisting
          percent
          newDealerPercent
          addedToExistingPercent
        }
        madeOrder {
          total
          newDealer
          addedToExisting
          percent
          newDealerPercent
          addedToExistingPercent
        }
        ordersSum {
          sum
          count
          newDealer {
            sum
            count
          }
          addedToExisting {
            sum
            count
          }
          newDealerPercent
          addedToExistingPercent
        }
        shippedSum {
          sum
          newDealer
          addedToExisting
          percent
          newDealerPercent
          addedToExistingPercent
        }
        noOrders {
          total
          newDealer
          addedToExisting
          percent
          newDealerPercent
          addedToExistingPercent
        }
      }
      perManager {
        managerId
        managerName
        ordersSumSharePercent
        metrics {
          received
          rejected
          rejectedPercent
          inProgress
          inProgressPercent
          averageProcessingTime
          dealerCreated {
            total
            newDealer
            addedToExisting
            percent
            newDealerPercent
            addedToExistingPercent
          }
          madeOrder {
            total
            newDealer
            addedToExisting
            percent
            newDealerPercent
            addedToExistingPercent
          }
          ordersSum {
            sum
            count
            newDealer {
              sum
              count
            }
            addedToExisting {
              sum
              count
            }
            newDealerPercent
            addedToExistingPercent
          }
          shippedSum {
            sum
            newDealer
            addedToExisting
            percent
            newDealerPercent
            addedToExistingPercent
          }
          noOrders {
            total
            newDealer
            addedToExisting
            percent
            newDealerPercent
            addedToExistingPercent
          }
        }
      }
      totals {
        received
        rejected
        inProgress
        averageProcessingTime
        dealerCreated {
          total
          percent
          newDealer
          addedToExisting
        }
        madeOrder {
          total
          percent
          newDealer
          addedToExisting
        }
        ordersSum {
          sum
          newDealer {
            sum
          }
          addedToExisting {
            sum
          }
        }
        shippedSum {
          sum
          percent
          newDealer
          addedToExisting
        }
        noOrders {
          total
          percent
          newDealer
          addedToExisting
        }
      }
    }
  }
`;
